import React, { useEffect, useState, useRef, useMemo, useCallback} from 'react';
import DataGrid, { SortDirection } from 'react-data-grid';
import './grid.css';

const highlightClassname = "highlightClassname";
const selectedHighlightClassname = "selectedHighlightClassname";

function Screen1Grid(props:any) {

    let gridData:any = props.gridData;
    let bulkData:any = props.bulkData;
    const initData:any  = props.initialization;
    const focusTarget:any = useRef();

    let selectedRowVarId:string = "";
    const [[sortColumn, sortDirection], setSort] = useState<[string, SortDirection]>(['bulk_name', 'NONE']);
    const handleSort = useCallback((columnKey: string, direction: SortDirection) => {
        setSort([columnKey, direction]);
      }, []);
    let [rows, setRows] = useState<any[]>([]);

    const columns = useMemo(() =>{
        return [
            {
                key: 'lineage_id_cindel',
                name: 'Lineage ID',
                frozen: true,
                resizable: true,
                sortable: true, 
                width: 80
            },
            {
                key: 'CHROM', 
                name: 'CHROM' ,
                resizable: true,
                sortable: true, 
                width: 100
            },
            { key: 'POS', name: 'POS', resizable: true, sortable: true, },
            { key: 'REF', name: 'REF', width: 80 , resizable: true, sortable: true, },
            { key: 'ALT', name: 'ALT', width: 80 , resizable: true, sortable: true, },
            { 
                key: 'Target_seq', 
                name: 'Target Seq', 
                width: 100,
                resizable: true,
                sortable: true, 
                formatter(selectedData:any){
                    return <div style={selectedData.row.Target_seq === "Y"?{ color:"red", fontWeight: "bold"}: {}}>{selectedData.row.Target_seq}</div>
            }
            },
            { key: 'Location',   name: 'Location' , resizable: true, sortable: true, },
            { key: 'Gene_name',   name: 'Gene name', resizable: true, sortable: true, width: 400,},
            { key: 'Exonic_variant_type', name: 'Exonic variant type' , resizable: true, sortable: true, },
            { key: 'Amino_acid_change',   name: 'Amino acid change' , resizable: true, sortable: true, },
        ];  
    },[rows]);
     
    
    let [cardTitle, setCardTitle] = useState<string>();

    initData.click_on_path = function(dataKeys:string[]) {
        let datas:any[] = [];

        let tempCardTitle:string = "Early embryonic mutations in " ;
        
        dataKeys.forEach(function(key,index){

            let separator:string = index === 0 ? " " : ", ";

            tempCardTitle += separator + key;

            if(gridData[key]){
                for(let i=0; i<gridData[key].length; i++){
                    datas.push(gridData[key][i]);
                }
            }
        });
        setCardTitle(tempCardTitle);
        setRows(datas)
        
        return datas;
    }

    function rowClick(rowNum: number, row: any){
        if(initData.click_on_row && row.Target_seq === "Y"){

            selectedRowVarId = row.var_id;

            initData.click_on_row(rowNum, row, bulkData);
            
            setTimeout(function(){
                focusTarget.current.scrollIntoView({ behavior: "smooth" });
            }, 500);
        }else{
            selectedRowVarId = "";
            initData.click_on_row(rowNum, row, bulkData);
        }
    }

    const sortedRows = useMemo(() =>{
        
        let sortedRows: any[] = [...rows];

        if (sortDirection === 'NONE') return sortedRows;

        switch (sortColumn) {
            case 'lineage_id_cindel':
            case 'Target_seq':
            case 'Location':
            case 'Gene_name':
            case 'Exonic_variant_type':
            case 'Amino_acid_change':
                sortedRows = sortedRows.sort((a, b) => a[sortColumn].localeCompare(b[sortColumn]));
                break;
            case 'CHROM':
            case 'POS':
            case 'REF':
            case 'ALT':
              sortedRows = sortedRows.sort((a, b) => a[sortColumn] - b[sortColumn]);
              break;
            default:
          }

        return sortDirection === 'DESC' ? sortedRows.reverse() : sortedRows;

    },[rows, sortDirection, sortColumn]);

    return (
        
        <React.Fragment>
            {rows.length > 0 && (
            <div ref={focusTarget} className="row">
            <div className="col-md-12">
                <div className="card card-primary">
                    <div className="card-header">
                    <h3 className="card-title">{cardTitle}</h3>
                    </div>
                    <div className="card-body">
                        <div >
                        <DataGrid
                            columns={columns}
                            rows={sortedRows} 
                            sortColumn={sortColumn}
                            sortDirection={sortDirection}
                            onSort={handleSort}
                            onRowClick={rowClick}
                            rowHeight={25}
                            headerRowHeight={35}
                            className="fill-grid"
                            rowClass={row => {
                                        if(selectedRowVarId === row.var_id){
                                            return selectedHighlightClassname;
                                        }
                                        return undefined;
                                    //  return row.Target_seq.includes('Y') ? highlightClassname : undefined
                                    }
                                }
                        />
                        </div>
                        <p className="card-text">
                        When you click an early mutation with available targeted-seq data, you can see the distribution of variant-allele frequency in the below panel.
                        </p>
                    </div>
                </div>
            </div>
            </div>
        )}
        </React.Fragment>
    );
}

export default Screen1Grid;